import { NavigateBefore } from "@mui/icons-material";
import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { alpha } from "@mui/material/styles";

export function CrudPage<T>({
  title,
  subtitle,
  children,
  headerActions,
}: { title: string; subtitle?: string; children: React.ReactNode; headerActions?: React.ReactNode }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: 'background.default', minHeight: '100vh' }}>
      <Box
        sx={{
          mb: 4,
          p: { xs: 1.5, sm: 2 },
          borderRadius: 4,
          background: (theme) => alpha(theme.palette.background.paper, 0.75),
          backdropFilter: 'blur(10px)',
          border: '1px solid',
          borderColor: 'divider',
          boxShadow: (theme) => `0 4px 20px ${alpha(theme.palette.primary.main, 0.06)}`,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0, flex: 1 }}>
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              borderRadius: 2,
              flexShrink: 0,
              '&:hover': { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.15) },
            }}
          >
            <NavigateBefore />
          </IconButton>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 900,
                color: 'text.primary',
                letterSpacing: '-0.02em',
                fontSize: { xs: '1.2rem', sm: '1.5rem' },
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        {headerActions && (
          <Box sx={{ width: { xs: '100%', sm: 'auto' }, display: 'flex' }}>
            <Box sx={{ width: { xs: '100%', sm: 'auto' }, '& .MuiButton-root': { width: { xs: '100%', sm: 'auto' } } }}>
              {headerActions}
            </Box>
          </Box>
        )}
      </Box>

      <Card
        elevation={0}
        sx={{
          borderRadius: 4,
          border: '1px solid',
          borderColor: 'divider',
          background: (theme) => alpha(theme.palette.background.paper, 0.75),
          backdropFilter: 'blur(10px)',
          boxShadow: (theme) => `0 4px 20px ${alpha(theme.palette.primary.main, 0.06)}`,
        }}
      >
        <CardContent sx={{ p: { xs: 1.5, sm: 2 }, '&:last-child': { pb: { xs: 1.5, sm: 2 } } }}>
          {children}
        </CardContent>
      </Card>
    </Box>
  );
}
